import React, { useContext, useState } from 'react';
import { Button } from '@progress/kendo-react-buttons';
import * as svg from '@progress/kendo-svg-icons';
import { Popover, PopoverActionsBar, Tooltip } from '@progress/kendo-react-tooltip';
import { FacebookCounter, GithubCounter, GithubSelector } from '@charkour/react-reactions';
import { IAction } from '../../../../types/Action/IAction';
import reactionsApi from '../../../../redux/api/ReactionApi';
import { Action } from '@progress/kendo-react-dateinputs';
import { IReaction } from '../../../../types/Ticket/IReaction';
import { RevUserContext } from '../../../../context/UserContext';
import { IUserProfile } from '../../../../types/User/IUserProfile';

const LikeButton: React.FC<IAction> = (action) => {
    const profile = useContext<IUserProfile>(RevUserContext)
    const { data: reactions } = reactionsApi.useGetReactionsQuery(action?.Call_Id, { skip: !profile?.Features.Like });
    const [addReaction, { isLoading }] = reactionsApi.useCreatReactionMutation();
    const [removeReaction, { isLoading: isDeleting }] = reactionsApi.useDeleteReactionMutation();

    const anchor = React.useRef(null);
    const [showSelector, setShowSelector] = React.useState(false);
    const myReaction = reactions?.find(r => r.Action_Id == action.ID && r.Staff_Id == profile?.Id);

    const handleRemove = (item) => {
        console.log('handleRemove', item, myReaction);
        if (myReaction) {
            removeReaction(myReaction).unwrap().then(() => {
                console.log('reaction removed');
            });
        }

    };

    const handleAdd = (item) => {
        //Hide the selector
        setShowSelector(false);

        var newReaction = {
            Id: myReaction ? myReaction.Id : 0,
            Call_Id: action?.Call_Id,
            Action_Id: action?.ID,
            Staff_Id: profile?.Id
        } as IReaction

        switch (item) {
            case '👍':
                newReaction.Reaction_Type = 1;
                break;
            case '👎':
                newReaction.Reaction_Type = 2;
                break;
            case '😄':
                newReaction.Reaction_Type = 3;
                break;
            case '🎉':
                newReaction.Reaction_Type = 4;
                break;
            case '😕':
                newReaction.Reaction_Type = 5;
                break;
            case '❤️':
                newReaction.Reaction_Type = 6;
                break;
            default:
            // code block
        }

        console.log('handleAdd', item, item == '👍', newReaction);

        addReaction(newReaction).unwrap().then(() => {
            console.log('reaction added');
        });
    }

    const TooltipContentTemplate = (props: any) => {
        return (
            <GithubSelector onSelect={handleAdd} />
        );
    }

    const actualReactions = reactions?.filter(r => r.Action_Id == action.ID)?.map((reaction) => {
        var em = '👍'
        switch (reaction.Reaction_Type) {
            case 2:
                em = '👎'
                break;
            case 3:
                em = '😄'
                break;
            case 4:
                em = '🎉'
                break;
            case 5:
                em = '😕'
                break;
            case 6:
                em = '❤️'
                break;
            default:
            // code block
        }

        return {
            emoji: em,
            by: reaction.Staff_Id == profile?.Id ? 'You' : reaction.Staff_Name.toString()
        }
    });

    //Create a window click event to close the popover
    React.useEffect(() => {
        const handleClick = (e) => {
            if (anchor.current && !anchor.current.contains(e.target)) {
                setShowSelector(false);
            }
        };
        window.addEventListener('click', handleClick);
        return () => window.removeEventListener('click', handleClick);
    }, []);

    if (!actualReactions || !action || action?.Is_System_Action || !profile?.Features.Like || action?.Action_Type_Id == 8) return <></>;

    return (
        <div ref={anchor} className='like-button'>
            <Popover className='reactions' anchor={anchor.current} offset={{ left: -15, top: 0 }} show={showSelector} position='top' callout={false}>
                <GithubSelector onSelect={handleAdd} />
            </Popover>
            <GithubCounter counters={actualReactions} user={profile?.F_Name + ' ' + profile?.L_Name} onSelect={handleRemove} onAdd={() => {
                //console.log('onAdd', event);
                //e.stopPropagation();
                setShowSelector((s) => !s)
            }} />
        </div>
    );
};

export default LikeButton;